import { createAnimation } from '@ionic/react'

export const modalSlideUpEnterAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot

  const duration = window?.innerWidth <= 768 ? 300 : 500

  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop') || ({} as any))
    .beforeStyles({ 'background-color': 'transparent', opacity: 0, translate: 'none' })
    .afterStyles({ 'background-color': 'transparent', opacity: 1, translate: 'none' })
    .duration(duration)

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.modal-wrapper') || ({} as any))
    .beforeStyles({ 'box-shadow': 'none' })
    .fromTo('transform', 'translateY(50px)', 'translateY(0px)')
    .to('opacity', 1)
    .duration(300)

  return createAnimation().addElement(baseEl).easing('ease-in-out').duration(300).addAnimation([backdropAnimation, wrapperAnimation])
}

export const modalSlideUpLeaveAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot

  const duration = window?.innerWidth <= 768 ? 300 : 500

  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop') || ({} as any))
    .beforeStyles({ 'background-color': 'transparent', opacity: 1, translate: 'none' })
    .afterStyles({ 'background-color': 'transparent', opacity: 0, translate: 'none' })
    .duration(duration)

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.modal-wrapper') || ({} as any))
    .beforeStyles({ 'box-shadow': 'none' })
    .fromTo('transform', 'translateY(0px)', 'translateY(50px)')
    .to('opacity', 0)
    .duration(300)

  return createAnimation().addElement(baseEl).easing('ease-in-out').duration(300).addAnimation([backdropAnimation, wrapperAnimation])
}

export const modalFadeInEnterAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot

  const duration = window?.innerWidth <= 768 ? 300 : 500

  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop') || ({} as any))
    .beforeStyles({ 'background-color': 'transparent', opacity: 0, translate: 'none' })
    .afterStyles({ 'background-color': 'transparent', opacity: 1, translate: 'none' })
    .duration(duration)

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.modal-wrapper') || ({} as any))
    .beforeStyles({ 'box-shadow': 'none' })
    .fromTo('transform', 'translateY(0px)', 'translateY(0px)')
    .to('opacity', 1)
    .duration(300)

  return createAnimation().addElement(baseEl).easing('ease-in-out').duration(300).addAnimation([backdropAnimation, wrapperAnimation])
}

export const modalFadeInLeaveAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot

  const duration = window?.innerWidth <= 768 ? 300 : 500

  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop') || ({} as any))
    .beforeStyles({ 'background-color': 'transparent', opacity: 1, translate: 'none' })
    .afterStyles({ 'background-color': 'transparent', opacity: 0, translate: 'none' })
    .duration(duration)

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.modal-wrapper') || ({} as any))
    .beforeStyles({ 'box-shadow': 'none' })
    .fromTo('transform', 'translateY(0px)', 'translateY(0px)')
    .to('opacity', 0)
    .duration(300)

  return createAnimation().addElement(baseEl).easing('ease-in-out').duration(300).addAnimation([backdropAnimation, wrapperAnimation])
}

export const defaultModalAnimations = {
  enterAnimation: modalSlideUpEnterAnimation,
  leaveAnimation: modalSlideUpLeaveAnimation
}

export const modalRightSlideInAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot

  const duration = window?.innerWidth <= 768 ? 300 : 500

  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop') || ({} as any))
    .beforeStyles({ 'background-color': 'transparent', opacity: 0, translate: 'none' })
    .afterStyles({ 'background-color': 'transparent', opacity: 1, translate: 'none' })
    .duration(duration)

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.modal-wrapper') || ({} as any))
    .beforeStyles({ 'box-shadow': 'none' })
    .fromTo('transform', 'translateX(100px)', 'translateX(0px)')
    .to('opacity', 1)
    .duration(300)

  return createAnimation().addElement(baseEl).easing('ease-in-out').duration(300).addAnimation([backdropAnimation, wrapperAnimation])
}

export const modalRightSlideOutAnimation = (baseEl: HTMLElement) => {
  const root = baseEl.shadowRoot

  const duration = window?.innerWidth <= 768 ? 300 : 500

  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop') || ({} as any))
    .beforeStyles({ 'background-color': 'transparent', opacity: 1, translate: 'none' })
    .afterStyles({ 'background-color': 'transparent', opacity: 0, translate: 'none' })
    .duration(duration)

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.modal-wrapper') || ({} as any))
    .beforeStyles({ 'box-shadow': 'none' })
    .fromTo('transform', 'translateX(0px)', 'translateX(100px)')
    .to('opacity', 0)
    .duration(300)

  return createAnimation().addElement(baseEl).easing('ease-in-out').duration(300).addAnimation([backdropAnimation, wrapperAnimation])
}

export const rightSlideModalAnimations = {
  enterAnimation: modalRightSlideInAnimation,
  leaveAnimation: modalRightSlideOutAnimation
}
